module.exports = __webpack_public_path__ + "h5/img/live-logo.84dd9e35.png";